import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserDetailsService } from '../../../../service/user-details.service';
import {
  PERMISSION_MANAGE_EDIFACT_RULE,
  PERMISSION_MANAGE_NDC_RULE
} from '../../../../service/user-permissions.service';

@Injectable({
  providedIn: 'root'
})
export class CanManageFlightGuard {
  constructor(private readonly userDetailsService: UserDetailsService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const permissions = this.userDetailsService.loggedInUser?.permissions ?? [];
    return (
      permissions.filter((p) => p === PERMISSION_MANAGE_EDIFACT_RULE || p === PERMISSION_MANAGE_NDC_RULE).length > 0
    );
  }
}
